// extracted by mini-css-extract-plugin
export default {"container":"SubscriptionSection-module__container--uhQPW","button":"SubscriptionSection-module__button--pP4tz","header":"SubscriptionSection-module__header--Q93Cn"};